import styled from "styled-components";
import { Device } from "../../../styles/screenSizes";

export const StyledModal = styled.div`
  background: white;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.25);
  max-width: 700px;
  width: 448px;
  outline: none;
  position: relative;
  border-radius: ${({ theme }) => theme.borderRadius ?? "20px"};

  @media ${Device.mobile} {
    margin: auto;
    min-width: 0;
    width: 100%;
  }
`;

export const StyledOverlay = styled.div`
  /* 
   Not using color constant "colors.black" here, because we want to add 0.4 alpha to the color,
   but since "colors.black" is a hex color value, doing something like rgba({colors.black}, 0.4)
   does not work. 
  */
  background-color: rgba(0, 0, 0, 0.4);
  bottom: 0;
  display: flex;
  left: 0;
  overflow: auto;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 10001;

  @media ${Device.notMobile} {
    align-items: center;
    justify-content: center;
  }
`;

export const StyledCloseButton = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
`;
